import {  put, takeLatest} from "redux-saga/effects";
import { push } from "connected-react-router";

const SEND_NEW_BRAND_SALE = "SEND_NEW_BRAND_SALE";
const EDIT_BRAND_SALE = "EDIT_BRAND_SALE";
const SUCCESS_NEW_BRAND_SALE = "SUCCESS_NEW_BRAND_SALE";
const ERROR_NEW_BRAND_SALE = "ERROR_NEW_BRAND_SALE";
const CLEAR_ERROR_NEW_BRAND_SALE = "CLEAR_ERROR_NEW_BRAND_SALE";
const SET_ERROR_NEW_BRAND_SALE = "SET_ERROR_NEW_BRAND_SALE";

const INITIAL_STATE = {
  isLoading: false,
  error: false,
  errorMessage: "",
  message: "",
};

const newBrandSaleReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SEND_NEW_BRAND_SALE:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case EDIT_BRAND_SALE:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case SUCCESS_NEW_BRAND_SALE:
      return {
        ...state,
        isLoading: false,
        message: payload,
      };
    case ERROR_NEW_BRAND_SALE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case SET_ERROR_NEW_BRAND_SALE:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };
    case CLEAR_ERROR_NEW_BRAND_SALE:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    default:
      return state;
  }
};

function sendNewBrandSale(body) {
  return { type: SEND_NEW_BRAND_SALE, body };
}
function editBrandSale(body, id) {
  return { type: EDIT_BRAND_SALE, body, id };
}
function setError(error) {
  return {
    type: SET_ERROR_NEW_BRAND_SALE,
    payload: error,
  };
}
function clearError() {
  return { type: CLEAR_ERROR_NEW_BRAND_SALE };
}

function* sendForm(action) {
  // const token = yield select((state) => state.login.token);
  // const auth = { headers: { authorization: `${token}` } };
  // const { body } = action;
  // const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/sales`;
  try {
    // const response = yield call(api_post, url, body, auth);
    yield put({
      type: SUCCESS_NEW_BRAND_SALE,
      payload: "Guardado con éxito",
    });
    yield put(push("/admin/marcas"));
  } catch (message) {
    yield put({
      type: ERROR_NEW_BRAND_SALE,
      payload: {
        message,
      },
    });
  }
}
function* editForm(action) {
  // const token = yield select((state) => state.login.token);
  // const auth = { headers: { authorization: `${token}` } };
  // const { body, id } = action;
  // const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/sales/${id}`;
  try {
    // const response = yield call(api_put, url, body, auth);
    yield put({
      type: SUCCESS_NEW_BRAND_SALE,
      payload: "Guardado con éxito",
    });
    yield put(push("/admin/marcas"));
  } catch (message) {
    yield put({
      type: ERROR_NEW_BRAND_SALE,
      payload: {
        message,
      },
    });
  }
}

function* newBrandSaleSaga() {
  yield takeLatest(SEND_NEW_BRAND_SALE, sendForm);
  yield takeLatest(EDIT_BRAND_SALE, editForm);
}

export {
  newBrandSaleSaga,
  newBrandSaleReducer,
  sendNewBrandSale,
  editBrandSale,
  setError,
  clearError,
};
